import { Copy, Eye, EyeOff } from 'lucide-react';
import React, { useState } from 'react'
import toast from 'react-hot-toast';
type Props = {
    value: string
}
export default function HandlePassword({ value }: Props) {
    const [showPassword, setShowPassword] = useState(false);
    const handleCopy = (text: string) => {
        navigator.clipboard.writeText(text);
        toast.success("Copied to clipboard!");
    };
    return (
        <>
            <button className="flex items-center gap-2 text-gray-500 hover:text-gray-700"   >
                <span>{showPassword ? value || "N/A" : "••••••••"}</span>
                <div className="text-gray-500 hover:text-gray-700" onClick={() => setShowPassword(!showPassword)}>
                    {showPassword ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
                </div>
                <Copy className="h-4 w-4" onClick={() => handleCopy(value)} />
            </button>
        </>
    )
}
